import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import { CatchupContentType } from './__types__/CatchupLastViewedTimeQuery';
import { CatchupLastViewedTimeQuery } from './CatchupLastViewedTimeQuery.graphql';

export function preloadAIFloatingContextMenu(contentId: string, isBlog: boolean) {
	const contentType = isBlog ? CatchupContentType.BLOGPOST : CatchupContentType.PAGE;
	return query({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: CatchupLastViewedTimeQuery,
		variables: {
			contentId,
			contentType,
		},
	});
}
